import { render, staticRenderFns } from "./associate-product.vue?vue&type=template&id=6ca18da2&"
import script from "./associate-product.vue?vue&type=script&lang=js&"
export * from "./associate-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports